import {Alert, Box, Button, Stack, Typography} from '@mui/material';
import copy from 'copy-to-clipboard';
import {useEffect} from 'react';
import {useApp} from '../../../context/AppContext';
import { useConfirm } from "material-ui-confirm";
import { CheckCircle  } from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import { dadosDoPix } from '../../../global/pix';

export default function ({data, mutate}) {
    const {socket} = useApp();
    const confirm = useConfirm()
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();
    useEffect(() => {
        if (socket) {
            socket.on(`order_${data.id}`, ({data}) => {
                if(data.status ==='CONCLUDED'){
                    confirm({content: <Stack alignItems="center" justifyContent="center" gap={3}>
                        <CheckCircle sx={{fontSize:80}} />
                        <Typography fontSize={16} fontWeight={700}>Seu pagamento foi aceito com sucesso</Typography>
                    </Stack> , title: 'Pagamento confirmado', hideCancelButton: true })
                }
                mutate();
            });
        }
        return () => {
            socket?.off(`order_${data.id}`);
        };
    }, [data,socket]);

    const pix = dadosDoPix(data.payment_details);

    return (
        <>
            {pix ? (
                <>
                    <Alert severity="warning" sx={{ width: '100%', borderRadius: '12px' }}>
                        Pagamento por Pix pendente. Escaneie o QR Code ou copie a chave para concluir.
                    </Alert>
                    {Boolean(pix.qr_code_url) && (
                        <Box
                            component="img"
                            width={300}
                            height={300}
                            ml="auto"
                            mr="auto"
                            sx={{borderRadius: 3, p: 2}}
                            src={pix.qr_code_url}
                            alt="QR Code do Pix"
                        />
                    )}
                    {Boolean(pix.qr_code) && (
                        <Button variant='outlined' onClick={() => {
                            copy(pix.qr_code)
                            enqueueSnackbar('Chave copiada')
                        }}>
                            Copiar Chave
                        </Button>
                    )}
                </>
            ) : (
                <Alert severity="info" sx={{ width: '100%', borderRadius: '12px' }}>
                    Pagamento por cartão em processamento. Você será notificado assim que for confirmado.
                </Alert>
            )}
        </>
    );
}
